import React from 'react';
import { Checkbox } from 'antd';
import cx from 'classnames';
import EhrBadge from '../EhrBadge';
import { ehrByName } from '../../constants';
import s from './s.module.less';

type Props = {
    names: string[];
    value: string[];
    onChange: (names: string[]) => void;
    // 不可勾选（所选 provider 在该 EHR 里都已关掉），标 Already off
    disabledNames?: string[];
};

// 原型 .ibbw-offgrid：两列 EHR 勾选卡片
export default function EhrTiles({ names, value, onChange, disabledNames = [] }: Props) {
    return (
        <div className={s.ehrGrid}>
            {names.map((n) => {
                const off = disabledNames.includes(n);
                const on = !off && value.includes(n);
                return (
                    <Checkbox
                        key={n}
                        className={cx(s.ehrCard, on && s.ehrCardOn, off && s.ehrCardOff)}
                        checked={on}
                        disabled={off}
                        onChange={(e) => onChange(e.target.checked ? [...value, n] : value.filter((v) => v !== n))}
                    >
                        <EhrBadge ehr={ehrByName(n)} />
                        <span className={s.ehrCardName}>{n}</span>
                        {off && <span className={s.offTag}>Already off</span>}
                    </Checkbox>
                );
            })}
        </div>
    );
}
